import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Terms = () => {
  const { language } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            {language === 'fr' ? "Conditions Générales d'Utilisation" : 'General Terms & Conditions'}
          </h1>
          <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
            Last modified: December, 01, 2025
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="container" style={{ maxWidth: '1000px' }}>
          
          <div style={{ 
            background: 'var(--bg-secondary)',
            padding: '24px',
            marginBottom: '32px',
            border: '1px solid var(--border-light)'
          }}>
            <p className="body-regular" style={{ lineHeight: 1.8, margin: 0 }}>
              EI Jérôme Serre exploitant la Marque Henry and Gaby et son Partenaire Sapphire Jet ("EI JEROME SERRE & Sapphire Jets"). 
              <br/><br/>
              <strong>EI JEROME SERRE</strong><br/>
              Siège Social : 20, rue des Capucins 77160 PROVINS<br/>
              Tel : +33 6 41 66 42 58<br/>
              n° de Siret : 441 777 992 00039<br/>
              Code APE : 7022Z<br/>
              n° de TVA intracommunautaire : FR 9644177799258
              <br/><br/>
              <strong>Sapphire Jets</strong><br/>
              996 Maine Ave Sw, Ste 733<br/>
              Washington, District of Columbia, 20024, United States
            </p>
          </div>

          <p className="body-regular" style={{ marginBottom: '32px', lineHeight: 1.8, fontStyle: 'italic' }}>
            EI JEROME SERRE & Sapphire Jets and Passenger are sometimes referred to herein collectively as the "Parties" and each as the "Party".
            <br/>
            Please read this provision carefully as it affects the Parties' legal rights.
          </p>

          {/* Section 1 */}
          <div style={{ marginBottom: '48px' }}>
            <h2 className="heading-1" style={{ marginBottom: '24px' }}>
              1. Services and Sharing Flight Services
            </h2>
            
            <div style={{ marginBottom: '24px' }}>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>1.1</h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Passenger appoints and authorizes EI JEROME SERRE & Sapphire Jets to act as agent for Passenger solely to arrange and pay for 1) Services and 2) Sharing Flight Services. Passenger hereby designates, constitutes, and appoints EI JEROME SERRE & Sapphire Jets as its true and lawful attorney-in-fact for the purposes of entering into 1) charter contracts for performance of the Flight Services and/or any Other Services and 2) contracts for Sharing Flight Services as Passenger's authorized agent.
              </p>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)', marginTop: '12px' }}>
                Passenger understands and agrees that EI JEROME SERRE & Sapphire Jets is an air charter broker and does not own or operate any aircraft. EI JEROME SERRE & Sapphire Jets may provide the Services and Sharing Flight Services under various databases, including EI JEROME SERRE & Sapphire Jets database.
              </p>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>1.2</h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                All Services and Sharing Flight Services are arranged on-demand according to the Passenger-directed itineraries and flight requirements. Services and Sharing Flight Services shall be provided by EI JEROME SERRE & Sapphire Jets Ltd together with aircraft operators/carriers holding an air operator certificate authorizing them to furnish air transportation services pursuant to applicable regulations which may be in effect from time to time ("Air Carrier(s)" on an aircraft under their operational control (the "Aircraft").
              </p>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>1.3</h3>
              <p className="body-regular" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
                Air Carrier shall have exclusive direction, control and authority over initiating, conducting, or terminating flights ("Operational Control"). Air Carriers shall be solely responsible for ensuring the safety of a flight and providing the Services and Sharing Flight Services, including the engagement of flight crew and the operation of the Aircraft. EI JEROME SERRE & Sapphire Jets is not a registered aircraft operator or air carrier, and it does not provide air operator/carrier services.
              </p>
            </div>
          </div>

          {/* Note pour économiser de l'espace */}
          <div style={{
            background: 'var(--bg-secondary)',
            padding: '24px',
            border: '1px solid var(--border-light)',
            marginTop: '48px'
          }}>
            <h3 className="heading-2" style={{ marginBottom: '16px' }}>
              Full Terms & Conditions
            </h3>
            <p className="body-regular" style={{ lineHeight: 1.8, marginBottom: '16px' }}>
              This document contains the complete General Terms & Conditions for EI JEROME SERRE & Sapphire Jets services, including:
            </p>
            <ul style={{ 
              paddingLeft: '24px', 
              margin: '16px 0',
              lineHeight: 1.8
            }}>
              <li className="body-regular" style={{ marginBottom: '8px' }}>Services and Sharing Flight Services</li>
              <li className="body-regular" style={{ marginBottom: '8px' }}>Booking Confirmation and Flight Costs</li>
              <li className="body-regular" style={{ marginBottom: '8px' }}>Payment Terms</li>
              <li className="body-regular" style={{ marginBottom: '8px' }}>Cancellation Policy</li>
              <li className="body-regular" style={{ marginBottom: '8px' }}>Force Majeure</li>
              <li className="body-regular" style={{ marginBottom: '8px' }}>Limitation of Liability</li>
              <li className="body-regular" style={{ marginBottom: '8px' }}>Governing Law</li>
            </ul>
            <p className="body-regular" style={{ lineHeight: 1.8, marginTop: '16px' }}>
              For the complete terms and conditions document, please contact us at{' '}
              <a href="mailto:contact@henry-and-gaby.com" style={{ color: 'var(--text-primary)', textDecoration: 'underline' }}>
                contact@henry-and-gaby.com
              </a>
            </p>
          </div>

          {/* Contact Information */}
          <div style={{ 
            marginTop: '48px',
            paddingTop: '32px',
            borderTop: '1px solid var(--border-light)'
          }}>
            <h3 className="heading-2" style={{ marginBottom: '16px' }}>
              Questions?
            </h3>
            <p className="body-regular" style={{ lineHeight: 1.8, marginBottom: '16px' }}>
              If you have any questions about these Terms & Conditions, please contact us:
            </p>
            <p className="body-regular" style={{ lineHeight: 1.8 }}>
              <strong>Email:</strong>{' '}
              <a href="mailto:contact@henry-and-gaby.com" style={{ color: 'var(--text-primary)', textDecoration: 'underline' }}>
                contact@henry-and-gaby.com
              </a>
              <br/>
              <strong>Phone:</strong> +33 6 41 66 42 58
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Terms;
